export function helpPosition(trigger: { left: number; top: number; bottom: number }, panel: { width: number; height: number }, viewport: { width: number; height: number }) {
  const edge = 16, gap = 8;
  const left = Math.max(edge, Math.min(trigger.left, viewport.width - panel.width - edge));
  const below = trigger.bottom + gap, above = trigger.top - panel.height - gap;
  const preferred = below + panel.height <= viewport.height - edge ? below : above >= edge ? above : below;
  const top = Math.max(edge, Math.min(preferred, viewport.height - panel.height - edge));
  return { left, top };
}
